import React, { useState, useEffect } from 'react';
import PlanCard from '../PlanCard';
import PlanDetailsModal from '../PlanDetailsModal'; // 1. Importa o novo componente de modal
import { fetchPlansNearby } from '../../services/api';

const PlanosInfoStep = ({ onPlanSelect }) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // 2. Cria um estado para controlar qual plano está selecionado para ver os detalhes
  const [selectedPlanForDetails, setSelectedPlanForDetails] = useState(null);

  useEffect(() => {
    const cep = localStorage.getItem('cep');
    if (cep) {
      fetchPlanos(cep);
    } else {
      setError('CEP não encontrado. Por favor, reinicie o processo.');
      setLoading(false);
    }
  }, []);

  async function fetchPlanos(cep) {
    try {
      const data = await fetchPlansNearby(cep);
      if (Array.isArray(data) && data.length === 0) {
        setError('Nenhum plano encontrado para o CEP fornecido.');
      } else if (data.message) {
        setError('Desculpe-nos, não encontramos Planos apropriados para o seu caso.');
      } else {
        setPlans(data);
        setError(null);
      }
    } catch (err) {
      console.error('Erro ao buscar planos:', err);
      setError('Infelizmente não temos planos disponíveis no momento.');
    } finally {
      setLoading(false);
    }
  }
  
  if (loading) {
    return (
      <div className="flex justify-center mt-6">
        <div className="w-8 h-8 border-4 border-[#E5E7EB] border-t-[#2A4DD0] rounded-full animate-spin" />
      </div>
    );
  }

  return (
    // O Fragment <> permite renderizar o modal como um "irmão" da div principal
    <>
      <div className="mt-6 w-full">
        {error ? (
          <div className="text-center p-6 bg-gray-100 rounded-lg">
            <p className="text-lg font-semibold text-gray-700">{error}</p>
          </div>
        ) : (
          <>
            <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">
              Planos disponíveis
            </h3>
            <div className="overflow-x-auto py-2">
              <div className="flex space-x-6 px-2">
                {plans.map((plano) => (
                  <div key={plano.id} className="flex-shrink-0 min-w-[300px]">
                    <PlanCard
                      logoTop="/newlogo.png"
                      logoLeft="/hapivida.webp"
                      planName={plano.plan_name}
                      // --- ALTERAÇÃO AQUI ---
                      // Verifica se o plano é o "Plano Nacional" para exibir o texto correto.
                      itens={
                        plano.plan_name === 'Plano Nacional'
                          ? ['Abrangência Nacional']
                          : (plano.hospitals ? [`Atende em ${plano.hospitals.length} hospitais na região`] : [])
                      }
                      preco={`R$${plano.plan_value}`}
                      // 3. O clique no botão agora define o plano a ser exibido no modal
                      onDetalhesClick={() => setSelectedPlanForDetails(plano)}
                      onSimularClick={() => onPlanSelect(plano)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      {/* 4. Renderiza o modal condicionalmente, apenas quando um plano for selecionado */}
      {selectedPlanForDetails && (
        <PlanDetailsModal
          plan={selectedPlanForDetails}
          onClose={() => setSelectedPlanForDetails(null)} // A função para fechar o modal
        />
      )}
    </>
  );
};

export default PlanosInfoStep;